import config from '../config';
import { RoutingProfilesResponse } from '../models/RoutingProfiles';

export const fetchRoutingProfiles = async (): Promise<RoutingProfilesResponse> => {
  const apiUrl = config.catoApiUrl;

  if (!apiUrl) {
    throw new Error('Agent Allocation API Url is not configured');
  }

  const url = `${apiUrl}/routing-profiles`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch routing profiles data: ${response.status} ${response.statusText}`);
  }

  let data = (await response.json()) as RoutingProfilesResponse;

  //TODO: Remove this from here once the backend is fixed to return proper JSON
  if (typeof data === 'string') {
    data = JSON.parse(data) as RoutingProfilesResponse;
  }

  return data;
};
